/**
 * Billy Stock Dot - FINAL
 *
 * 1. Au load: collecter tous les variant IDs depuis data-variant-map
 * 2. Fetcher toutes les variantes en background idle -> construire billyTable
 * 3. Surveiller les changements d URL (pushState + popstate)
 * 4. A chaque URL change: relire la table et appliquer les dots sur les nouvelles cards
 */

(function () {
  'use strict';

  var BILLY   = 'Billy (Brussels)';
  var READY   = 'Usually ready';
  var BATCH   = 5;
  var TIMEOUT = 5000;
  var MAX_CON = 4;

  // billyTable: variantId -> true | false
  var billyTable = {};
  var fetched    = {};
  var active     = 0;
  var fetchQ     = [];

  // -------------------------------------------------------
  // FETCH ENGINE
  // -------------------------------------------------------

  function drain() {
    while (fetchQ.length > 0 && active < MAX_CON) {
      var job = fetchQ.shift();
      active++;
      (function (id, cb) {
        var ctrl  = new AbortController();
        var timer = setTimeout(function () { ctrl.abort(); }, TIMEOUT);
        fetch('/variants/' + id + '/?section_id=pickup-availability', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: ctrl.signal
        })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            clearTimeout(timer);
            billyTable[id] = isB(html);
            cb(billyTable[id]);
          })
          .catch(function () {
            clearTimeout(timer);
            billyTable[id] = false;
            cb(false);
          })
          .then(function () { active--; drain(); });
      }(job.id, job.cb));
    }
  }

  function fetchOne(id) {
    if (id in billyTable) return Promise.resolve(billyTable[id]);
    return new Promise(function (res) {
      fetchQ.push({ id: id, cb: res });
      drain();
    });
  }

  function isB(html) {
    if (!html) return false;
    var i = html.indexOf(BILLY);
    if (i === -1) return false;
    return html.substring(Math.max(0, i - 50), i + 400).indexOf(READY) !== -1;
  }

  // -------------------------------------------------------
  // TABLE BUILDER
  // Fetch toutes les variantes de la page en idle
  // Appelle onComplete quand tout est fetché
  // -------------------------------------------------------

  function buildTable(onComplete) {
    var ids = [];
    document.querySelectorAll('.billy-stock-dot-slot').forEach(function (s) {
      var map = s.dataset.variantMap || '';
      map.split(',').forEach(function (entry) {
        var id = entry.split('|')[0].trim();
        if (id && !(id in fetched)) {
          fetched[id] = true;
          ids.push(id);
        }
      });
    });

    if (!ids.length) { if (onComplete) onComplete(); return; }

    var batches = [];
    for (var i = 0; i < ids.length; i += BATCH) {
      batches.push(ids.slice(i, i + BATCH));
    }

    var done = 0;

    function schedNext(remaining) {
      if (!remaining.length) {
        if (onComplete) onComplete();
        return;
      }
      function run(dl) {
        while (remaining.length) {
          var tl = dl ? dl.timeRemaining() : 10;
          if (tl < 2 && remaining.length > 1) break;
          var batch = remaining.shift();
          Promise.all(batch.map(fetchOne)).then(function () {
            done += batch.length;
            applyDots(); // afficher les dots au fil du prefetch
          }).catch(function () {});
        }
        if (remaining.length) schedNext(remaining);
      }
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(run, { timeout: 2000 });
      } else {
        setTimeout(function () { run(null); }, 30);
      }
    }

    schedNext(batches);
  }

  // -------------------------------------------------------
  // APPLY DOTS
  // Lit la table et applique les dots sur les cards visibles
  // -------------------------------------------------------

  function getActiveOpts() {
    var params = new URLSearchParams(window.location.search);
    var vals   = {};
    params.forEach(function (val, key) {
      if (/^filter\.[vp]\.option\./i.test(key) && val) {
        vals[val.toLowerCase().trim()] = true;
      }
    });
    return vals;
  }

  function getRelevantIds(slot) {
    var map      = slot.dataset.variantMap || '';
    var opts     = getActiveOpts();
    var hasOpts  = Object.keys(opts).length > 0;
    var entries  = map.split(',');
    var ids      = [];

    for (var i = 0; i < entries.length; i++) {
      var parts = entries[i].trim().split('|');
      var id    = parts[0];
      if (!id) continue;

      if (!hasOpts) {
        ids.push(id);
        continue;
      }

      // Matcher toutes les options actives
      var varOpts = {};
      for (var j = 1; j < parts.length; j++) {
        if (parts[j]) varOpts[parts[j].toLowerCase().trim()] = true;
      }
      var allMatch = true;
      for (var ov in opts) {
        if (!varOpts[ov]) { allMatch = false; break; }
      }
      if (allMatch) ids.push(id);
    }
    return ids;
  }

  function showDot(slot) {
    if (slot.querySelector('.billy-stock-dot')) return;
    slot.innerHTML =
      '<div class="billy-stock-dot">' +
        '<svg width="14" height="14" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<circle cx="7.5" cy="7.5" r="7.5" fill="#22c55e" opacity="0.25"></circle>' +
          '<circle cx="7.5" cy="7.5" r="5" fill="#22c55e" stroke="#fff" stroke-width="1.5"></circle>' +
        '</svg>' +
        '<span class="billy-stock-dot__label">@Billy</span>' +
      '</div>';
  }

  function hideDot(slot) {
    slot.innerHTML = '';
    slot.setAttribute('aria-hidden', 'true');
  }

  function applyDots() {
    document.querySelectorAll('.billy-stock-dot-slot').forEach(function (slot) {
      var ids = getRelevantIds(slot);

      if (!ids.length) { hideDot(slot); return; }

      // Vérifier combien sont dans la table
      var known  = 0;
      var hasBilly = false;
      for (var i = 0; i < ids.length; i++) {
        if (ids[i] in billyTable) {
          known++;
          if (billyTable[ids[i]]) hasBilly = true;
        }
      }

      if (known === ids.length) {
        // Table complète pour ce produit: décision immédiate
        hasBilly ? showDot(slot) : hideDot(slot);
      } else if (hasBilly) {
        // Au moins un hit connu: afficher maintenant
        showDot(slot);
      }
      // Sinon: pas encore assez de données, on attend le prochain applyDots()
    });
  }

  // -------------------------------------------------------
  // URL WATCHER
  // Intercepte pushState + popstate pour détecter les filtres S&D
  // -------------------------------------------------------

  function onUrlChange() {
    // Légère attente pour que Dawn ait fini le re-render innerHTML
    setTimeout(function () {
      applyDots();
      buildTable(applyDots); // fetcher les nouvelles variantes si besoin
    }, 150);
  }

  function watchUrl() {
    // Intercepter history.pushState
    var origPush    = history.pushState.bind(history);
    var origReplace = history.replaceState.bind(history);

    history.pushState = function () {
      origPush.apply(history, arguments);
      onUrlChange();
    };
    history.replaceState = function () {
      origReplace.apply(history, arguments);
      onUrlChange();
    };

    // Bouton Back/Forward
    window.addEventListener('popstate', onUrlChange);
  }

  // -------------------------------------------------------
  // BOOT
  // -------------------------------------------------------

  function boot() {
    watchUrl();
    buildTable(applyDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // -------------------------------------------------------
  // PUBLIC HOOK
  // Permet au JS de scroll infini / recherche de demander un
  // rescan apres l'ajout de nouvelles cards dans le DOM
  // (le watcher d'URL ci-dessus ne couvre que les changements
  // d'URL, pas les ajouts dynamiques de contenu).
  // -------------------------------------------------------
  window.BillyStockDot = {
    refresh: function () {
      buildTable(applyDots);
    }
  };

}());
